export const PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_desktop_bx775_saved_search_favorites_merge';

export const MOBILE_SEARCH_STRING_AND_FF_EXPERIMENT = 'aud_mobile_bx1170_search_string_and_ff';

export const MORTGAGE_SHORT_FORM_EXPERIMENT = 'b2c_txn1366_short_form_web';

export const EXPERIMENTS = [
  PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
  MOBILE_SEARCH_STRING_AND_FF_EXPERIMENT,
  MORTGAGE_SHORT_FORM_EXPERIMENT,
];
